import React from 'react';
import {useScopeTranslation} from '@uigstudio/uig-nextjs-helper';

import PlusIcon from '~assets/images/icons/ui/plus.svg';
import MinusIcon from '~assets/images/icons/ui/minus.svg';
import LocationIcon from '~assets/images/icons/ui/location.svg';
import {dmsCoordinates} from '~utils/plot/coordinates';
import {defaultBounds} from '~constants/map';
import {MapRef} from '~types/Map';
import useZoomEvent from '~utils/map/events/useZoomEvent';
import usePitchToggle from '~utils/map/usePitchToggle';
import useMousePosition from '~utils/map/events/useMousePosition';
import useCenterMapEvent from '~utils/map/events/useCenterMapEvent';

import {ControlButton, Coordinate, MapControlsContainer, Row} from './styles';

type MapControlsProps = {
    mapRef: MapRef;
};
const MapControls: React.FC<MapControlsProps> = ({mapRef}) => {
    const t = useScopeTranslation('map', 'controls');
    const {zoomIn, zoomOut} = useZoomEvent(mapRef);
    const {is3D, toggle3D} = usePitchToggle(mapRef);
    const [lng, lat] = useMousePosition(mapRef);
    const {centerToBounds} = useCenterMapEvent(mapRef);

    return (
        <MapControlsContainer>
            <Row>
                <ControlButton onClick={() => centerToBounds(defaultBounds)}>
                    <LocationIcon />
                </ControlButton>
                <ControlButton onClick={toggle3D}>
                    {t(is3D ? '2D' : '3D')}
                </ControlButton>
                <div>
                    <ControlButton flatBottom onClick={zoomIn}>
                        <PlusIcon width={18} height={18} />
                    </ControlButton>
                    <ControlButton onClick={zoomOut} flatTop>
                        <MinusIcon />
                    </ControlButton>
                </div>
            </Row>
            <Coordinate>{dmsCoordinates([lng, lat])}</Coordinate>
        </MapControlsContainer>
    );
};

export default MapControls;
